import React, {ReactNode, FC} from 'react';
import Header from './header';
import Footer from './footer';
import PageHero, {type PageHeroVariant} from './pagehero';
import CookieConsentPopup from '../cookies-popup';

import './styles.scss';

interface LayoutProps {
  children: ReactNode;
  pageheroText?: string;
  pageheroTitle?: any;
  pageheroImg?: string;
  pageheroColor?: string;
  pageheroVariant?: PageHeroVariant;
  className?: string;
  startenginePage?: boolean;
}

const Layout: FC<LayoutProps> = ({
  children,
  pageheroText,
  pageheroTitle,
  pageheroImg,
  pageheroColor,
  pageheroVariant,
  className,
  startenginePage,
}) => {
  const showPageHero =
    pageheroText && pageheroTitle && pageheroImg && (pageheroColor || pageheroVariant === 'second-brain');

  return (
    <div className={`page-container ${className ? className : ''}`}>
      <div className="content-wrap">
        <Header startenginePage={startenginePage} />
        {showPageHero && (
          <PageHero
            text={pageheroText}
            title={pageheroTitle}
            img={pageheroImg}
            color={pageheroColor || '#111827'}
            variant={pageheroVariant}
          />
        )}
        <div className="content-wrapper">{children}</div>
      </div>
      <CookieConsentPopup />
      <Footer />
    </div>
  );
};

export default Layout;
